import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export type AdminLanguage = 'en' | 'zh' | 'ko';
interface AdminState {
  adminLanguage: AdminLanguage;
  setAdminLanguage: (adminLanguage: AdminLanguage) => void;
}

export const useAdminStore = create<AdminState>()(
  persist(
    devtools(
      immer((set) => ({
        adminLanguage: 'en',
        setAdminLanguage: (adminLanguage) => set(() => ({ adminLanguage })),
      }))
    ),
    { name: 'csr_admin', storage: createJSONStorage(() => localStorage) }
  )
);
